import { render, staticRenderFns } from "./LayoutManager.vue?vue&type=template&id=2d428d8c&scoped=true&"
import script from "./LayoutManager.vue?vue&type=script&lang=js&"
export * from "./LayoutManager.vue?vue&type=script&lang=js&"
import style0 from "./LayoutManager.vue?vue&type=style&index=0&id=2d428d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d428d8c",
  null
  
)

export default component.exports